import { IconMonitorOutline18 as Monitor } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

import type { TimelineEventProps } from "./types"
import { DeviceInfoLine, parseDeviceInfoText } from "./device-info-line"

export function DeviceInfoEvent({
	event,
	hasEventAbove = false,
	hasEventBelow = false,
}: TimelineEventProps) {
	if (event.type !== "comment") return null

	const parsed = parseDeviceInfoText(event.comment.content)
	if (!parsed) return null

	return (
		<div
			className={cn(
				"flex max-w-full flex-nowrap items-center gap-3 text-xs",
				hasEventAbove ? "pt-0" : "pt-1",
				hasEventBelow ? "pb-0" : "pb-1",
			)}
		>
			<div className="flex w-8 min-w-8 flex-col items-center">
				<div
					className={cn(
						"h-2 w-[0.5px]",
						hasEventAbove
							? "bg-gray-300 dark:bg-gray-600"
							: "bg-gradient-to-t from-gray-300 to-transparent dark:from-gray-600",
					)}
				/>
				<div className="my-0.5 flex items-center justify-center">
					<Monitor className="h-4 min-h-4 w-4 min-w-4 text-gray-400" />
				</div>
				<div
					className={cn(
						"h-2 w-[0.5px]",
						hasEventBelow
							? "bg-gray-300 dark:bg-gray-600"
							: "bg-gradient-to-b from-gray-300 to-transparent dark:from-gray-600",
					)}
				/>
			</div>
			<DeviceInfoLine text={parsed.text} className="min-w-0 flex-1" />
		</div>
	)
}
